export const GET_BAGGAGE_MANIFEST_PRINT = 'GET_BAGGAGE_MANIFEST_PRINT';
export const CLEAR_BAGGAGE_MANIFEST_PRINT = 'CLEAR_BAGGAGE_MANIFEST_PRINT';
export const FLAG_GETTING_BAGGAGE_MANIFEST_PRINT =
  'FLAG_GETTING_BAGGAGE_MANIFEST_PRINT';
